// @flow
import idx from "idx";
import type { Tournament } from "../../../redux/CommonTypes";

export function getRefillCosts({ account, refill_costs = [] }: Tournament) {
  let count = 0;
  const { length } = refill_costs;

  // TODO: what should we do here? Return null? 0? Check length earlier?
  if (!length)
    return {
      cost_usd: null,
      cost: null
    };

  const refill_count = idx(account, acc => acc.refill_count);

  if (refill_count != null) {
    count = refill_count;

    if (count >= length) {
      count = length - 1;
    }
  }

  const { cost_usd, cost } = refill_costs[count];
  return { cost_usd, cost };
}

type CalcProps = {
  account_money: string,
  refill: number
};

export function calcBalancePercentage(props: CalcProps) {
  const { refill, account_money } = props;

  if (refill === false) {
    return 0;
  }

  return (parseFloat(account_money) * parseFloat(refill)) / 100;
}

type DisableProps = {
  tournament: ?Tournament,
  api: any
};

export function disableRefill({ tournament = null, api }: DisableProps) {
  // true - рефилл невозможен,
  // false - рефилл возможен
  const active_tournament = idx(
    api.readEntity(`/api/tournaments/stats`),
    stats => stats.value.active_tournament
  );

  if (active_tournament == null) {
    return true;
  }

  if (tournament == null) {
    tournament = active_tournament;
  } else if (tournament.id !== active_tournament.id) {
    return true;
  }

  const { account } = tournament;

  if (tournament.refill !== false && account != null) {
    if (
      tournament.refill_limit !== false &&
      account.refill_count >= tournament.refill_limit
    ) {
      return true;
    }

    let openOperationsSum = 0;
    const opsData = api.readEntity(
      `/api/tournaments/operations?account_id=${account.id}`
    );

    if (opsData.status === "Pending") {
      return true;
    }

    const ops = idx(opsData, data => data.value.open);

    if (ops == null) {
      return true;
    }

    openOperationsSum = ops.reduce((acc, op) => acc + op.amount, 0);

    const refill = calcBalancePercentage(tournament);
    const { cost_usd, cost } = getRefillCosts(tournament);

    if (
      parseFloat(account.balance) + openOperationsSum <= refill &&
      cost_usd !== null &&
      cost !== null
    ) {
      return false;
    }
  }

  return true;
}



// WEBPACK FOOTER //
// ./src/components/Tournaments/helpers/refill.js